import { CartSheetWidgetElement } from './define-cart-sheet-element';

export function registerCartSheetWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-cart-sheet-widget')) return;

  window.customElements.define('adipa-cart-sheet-widget', CartSheetWidgetElement);
}
